// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-container {
  padding: 20px;
}
/* Button */
.stories-btn {
    float:right;
   /* margin-top: -20px;  */
  /* padding: 8px 14px; */
  border: none;
  background: #2563eb;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
}

.list-item {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.list-item h3 {
  margin: 0;
}

.list-item p {
  margin: 4px 0;
  color: #555;
}

.list-item a {
  font-size: 14px;
  color: blue;
  text-decoration: underline;
}

.quote-title {
  color: black;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/published-stories/publishedStories.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA,WAAW;AACX;IACI,WAAW;GACZ,wBAAwB;EACzB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".list-container {\n  padding: 20px;\n}\n/* Button */\n.stories-btn {\n    float:right;\n   /* margin-top: -20px;  */\n  /* padding: 8px 14px; */\n  border: none;\n  background: #2563eb;\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.list-item {\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.list-item h3 {\n  margin: 0;\n}\n\n.list-item p {\n  margin: 4px 0;\n  color: #555;\n}\n\n.list-item a {\n  font-size: 14px;\n  color: blue;\n  text-decoration: underline;\n}\n\n.quote-title {\n  color: black;\n  margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
